import type { HTMLAttributes } from 'react';
import styled from 'styled-components';

export const AuditLogContainer = styled.div<
  { $disableLegacyStyles?: boolean } & HTMLAttributes<HTMLDivElement>
>`
  overflow-y: scroll;
  width: 100%;
  height: 1000px;
  padding: 20px 0;
  ${(props) =>
    props.$disableLegacyStyles
      ? ''
      : `
  margin: 20px auto;
  `}
`;

export const LoadingContainer = styled.div`
  text-align: center;
  margin-top: 50px;
`;
